const authorFromScratch = {
  topicId: "nualang.author-from-scratch.0.0.1",
  topicName: "Create Your Own",
  description: "",
  difficulty: "ALL",
  learnLang: "english",
};

export default authorFromScratch;
